module.exports = __webpack_public_path__ + "assets/images/no-cover.16f79148.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no-cover.png
// module id = 905
// module chunks = 1